import { Outlet } from "react-router";
import Header from "./components/Header";
import MenuWrapper from "./components/MenuWrapper";

export default function MainLayout() {
  return (
    <div className="flex bg-gray-100 min-h-screen font-fish text-xxs">
      <div className="flex-grow overflow-x-auto">
        <Header />
        <MenuWrapper />
        <Outlet />
      </div>
    </div>
  );
}
